var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex p-6 text-center",
      attrs: { id: "thematic-modal-wrapper" }
    },
    [_vm._v("\n  Coming soon!\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }